export default "__VITE_ASSET__14478680__"